
import { PrismicLayoutType } from '@/constants/prismicContent';
import MarketplaceForProsStoreName from '@/store/marketplace-for-pros/name';
import { getAction, SET_CONTENT_DATA } from '@/store/marketplace-for-pros/actions';
import MetaHead from '@/mixins/MetaHead';
import MarketplaceForProsHeroSection from '@/components/page-specific/pro-marketplace/marketplace-for-pros/hero-section';
import MarketplaceForProsDescriptionSection from '@/components/page-specific/pro-marketplace/marketplace-for-pros/description-section';
import MarketplaceForProsCardSection from '@/components/page-specific/pro-marketplace/marketplace-for-pros/card-section';
import MarketplaceForProsHowItWorksSection from '@/components/page-specific/pro-marketplace/marketplace-for-pros/how-it-works-section';
import MarketplaceForProsFooterSection from '@/components/page-specific/pro-marketplace/marketplace-for-pros/footer-section';

export default {
  name: 'MarketplaceForPros',
  components: {
    MarketplaceForProsDescriptionSection,
    MarketplaceForProsCardSection,
    MarketplaceForProsHowItWorksSection,
    MarketplaceForProsFooterSection,
    MarketplaceForProsHeroSection,
  },
  mixins: [MetaHead],
  data() {
    return {
      PrismicLayoutType,
    };
  },
  async fetch() {
    if (this.isContentLoaded) {
      return;
    }

    const { data } = await this.getContent();

    this.meta.title = data.meta_title;
    this.meta.description = data.meta_description;

    await this.$store.dispatch(getAction(SET_CONTENT_DATA), data);
  },
  computed: {
    isContentLoaded() {
      return this.$store.state[MarketplaceForProsStoreName].isContentLoaded;
    },
  },
  methods: {
    getContent() {
      return this.$prismic.client.getSingle(PrismicLayoutType.MarketplaceForPros);
    },
  },
};
